export const parseLocationSearchParams = (search) => {
    var searchParams = new URLSearchParams(search);
    let searchObj = {};
    for (let p of searchParams) {
        searchObj = { ...searchObj, [p[0]]: p[1] };
    }
    return searchObj;
};
